import { render, staticRenderFns } from "./jgbkd.vue?vue&type=template&id=5391666e&scoped=true"
import script from "./jgbkd.vue?vue&type=script&lang=js"
export * from "./jgbkd.vue?vue&type=script&lang=js"
import style0 from "./jgbkd.vue?vue&type=style&index=0&id=5391666e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5391666e",
  null
  
)

export default component.exports